<template>
  <div v-bind:class="isSurvey">

    <div class="gutter-horizontal" :class="fullTemplate.gutter" v-if="loggedIn">
      <div v-for="(page, index) in pages" v-bind:key="index" class="slide" v-bind:class="[slide_active(index).class, slide_in_queue(index)]">
        <component v-bind:is="page.template" v-bind:content="page.content" v-bind:title="page.title" v-bind:active="slide_active(index).bool">
          {{page.content}}
        </component>
      </div>
    </div>

    <progress-bar :complete="percentComplete" :hidden="fullTemplate.progressHidden" v-if="loggedIn"></progress-bar>

    <page-bar v-if="loggedIn"></page-bar>

    <readButton v-if="loggedIn" />

    <navbar :nextCondition="nextCondition" v-if="loggedIn"></navbar>

    <notification v-bind:state="notification_state" v-bind:captionState="caption_state" v-if="loggedIn"></notification>

    <login></login>

    <landing-screen v-if="landingFirstComplete"></landing-screen>
    <landing-first v-on:complete="landingFirstCompleteCb" />

  </div>
</template>

<style scoped lang="scss">
  @import '../styles/variables';

  .slide {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.9s ease-in-out, opacity 1.8s ease-in-out;
    &.page-inactive {
      transform: translateX(-200%);
      opacity: 0;
      @media screen and (max-width: $md-max), screen and (max-height: $md-height-max) {
        position: fixed;
        width: calc(100% - 80px - 80px);
        margin-left: 80px;
      }
      @media screen and (max-width: $sm-max) {
        width: 100%;
      }
    }
    @media screen and (max-width: $md-max),
    screen and (max-height: $md-height-max) {
      position: relative;
      height: auto;
      width: auto;
    }
  }

  .pdf-link {
    position: absolute;
    bottom: 0;
    left: 0;
    background: $debug;
    text-align: center;
    z-index: 99 !important;
  }

</style>

<script>
  import navbar from '../components/organisms/navbar'
  import progressBar from '../components/organisms/progressBar'
  import pageBar from '../components/organisms/pageBar'
  import notification from '../components/organisms/notification'
  import login from '../components/organisms/login'
  import landing from '../components/organisms/landing'
  import landingFirst from '../components/organisms/landingFirst'
  import readButton from '../components/organisms/readButton'
  import pages from './pages'

  import contentful_init from '../contentful'
  // import {getAllPages} from '../contentful/contentfulAllPages'

  // todo: set nextcondition to pass a function to store, which can then handle all conditoinal logic/return and disable nav if something is off.

  export default {
    data() {
      return {
        isSurvey: '',
        landingFirstComplete: false
      }
    },
    computed: {
      loggedIn() {
        return this.$store.state.loggedIn
      },
      pages() {
        return this.$store.state.pages
      },
      notification_state() {
        return this.$store.state.notification_state
      },
      caption_state() {
        return this.$store.state.checkbox
      },
      nextCondition() {
        return this.$store.state.nextCondition
      },
      percentComplete() {
        let curr = this.$store.state.page
        let len = this.$store.state.pages.length
        return curr / len
      },
      fullTemplate() {

        let defaultClasses = {
          gutter: '',
          progressHidden: false
        }

        if (!this.$store.state.pages[this.$store.state.page]) return defaultClasses

        const fullTemplates = ['pre-survey', 'post-survey']
        let currentTemplate = this.$store.state.pages[this.$store.state.page].template

        for (let i = 0; i < fullTemplates.length; i++) {
          if (fullTemplates[i].indexOf(currentTemplate) !== -1) {
            return {
              gutter: 'gutter-full',
              progressHidden: true
            }
          }
        }

        return defaultClasses

      }
    },
    methods: {
      landingFirstCompleteCb () {
        // setTimeout(() => {
          this.landingFirstComplete = true;
        // }, 500)
      },
      slide_active(page) {
        let current_page = this.$store.state.page
        if (current_page !== page) {
          return {
            class: 'page-inactive',
            bool: false
          }
        } else {
          return {
            class: '',
            bool: true
          }
        }
      },
      slide_in_queue(this_page) {

        // set to 'display: none' / .hide-all if not directly before or after slide ( prevent crashes )
        let current_page = this.$store.state.page

        if (this_page < current_page - 1 || this_page > current_page + 1) {
          return 'hide-all'
        } else {
          return ''
        }

      }
    },
    components: {
      navbar,
      notification,
      login,
      'progress-bar': progressBar,
      'page-bar': pageBar,
      'landing-screen': landing,
      'landing-first': landingFirst,
      ...pages,
      readButton,
      // ...svg
    },
    mounted() {
      // get pages
      contentful_init(this, 'set_pages')
      // getAllPages()
    }
  }

</script>



// WEBPACK FOOTER //
// main.vue?1753f990